import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import dayEntriesReducer from "./dayentries";
import petBgReducer from "./petBgReducer";
import sessionReducer from "./session";
import userTasksReducer from "./userTaskReducer";

const rootReducer = combineReducers({
  // add reducer functions here
  session: sessionReducer,
  day: dayEntriesReducer,
  tasks: userTasksReducer,
  items: petBgReducer
});

let enhancer;

if (process.env.NODE_ENV === "production") {
  enhancer = applyMiddleware(thunk);
} else {
  const logger = require("redux-logger").default;
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  enhancer = composeEnhancers(applyMiddleware(thunk, logger));
}

const configureStore = (preloadedState) => {
  return createStore(rootReducer, preloadedState, enhancer);
};

export default configureStore;
